// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3O_JzIvV","title":"_1VwYxVkZ","seeMore":"_1VdWnLI5","pillType":"_21bFjxq2","pillChild":"_3be6cUyW","suggestedPill":"_3tqbKRPc","suggestionName":"_2TAHHCe-"};